import { Localization } from '@approvalmax/utils';
import en from 'i18n/en.json';

export const { defineMessage, t } = new Localization({
    localizationMap: en,
    locale: 'en',
});
